import { RequestHandler } from "@lib/titan2-slingo/dist/api/RequestHandler";
import { Slingo } from "@lib/titan2-slingo/dist/api/Slingo";
import { RequestConstants } from "@lib/titan2/dist/api/core/request/RequestConstants";
export class PawnshopSlingo extends Slingo {
    static log(parameters, action, scope) {
        let URL = "/slingo/" + Slingo.gameType + "/games/" + Slingo.gameId + "/" + PawnshopSlingo.requestsMap.log.action;
        new RequestHandler(parameters, action, scope, URL, PawnshopSlingo.requestsMap.log).run();
    }
}
PawnshopSlingo.requestsMap = {
    ...Slingo.requestsMap,
    log: {
        name: "log",
        action: "log",
        dataClass: null,
        Method: RequestConstants.POST,
    }
};
//# sourceMappingURL=PawnshopSlingo.js.map